import { profileSystems } from '../data/mockData';

/** Dominant profile system across saved drawings (most frequent selection). */
export const resolveOrderProfileSystemId = (savedQuotes = []) => {
  const counts = {};

  savedQuotes.forEach((quote) => {
    const id = quote?.config?.profileSystem;
    if (id) counts[id] = (counts[id] || 0) + 1;
  });

  const ranked = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  if (ranked.length > 0) return ranked[0][0];

  return savedQuotes[0]?.config?.profileSystem || profileSystems[0]?.id || 'synego';
};

/** Headline label for the profile block on the VMK spec page. */
export const getProfileSpecLead = (profileSystemId) => {
  const profile = profileSystems.find((p) => p.id === profileSystemId);
  if (!profile) return 'VEKA Softline 82 NL';

  if (profile.id === 'synego') {
    return 'VEKA Softline 82 NL';
  }

  if (profile.id === 'schuco') {
    return 'Schüco';
  }

  const description = (profile.description || '').trim();
  return description ? `${profile.name} ${description}`.trim() : profile.name;
};
